<template>
  <div class="container">
    <div class="df no-pro" v-if="!collectList || collectList.length==0">
      <img src="../../assets/img/home_default.png" alt="">
      <p>你还没有创建的收藏夹<br />快去发现有趣的作品吧~</p>
      <div class="share-btn" @click="addFolder">创建收藏夹</div>
    </div>
    <div class="collect-box" v-if="collectList.length>0">
      <ul class="collect-list clearfix">
        <li class="fl collect-item">
          <div class="df add-box" @click="addFolder">
            <div class="add">+</div>
            <p>创建收藏夹</p>
          </div>
        </li>
        <router-link tag="li" class="fl collect-item" v-for="(item,index) in collectList" :key="index" :id="item.Id" :to="'/homepage/collectDetail/'+item.Id+'/'+item.Name+'?uid='+userId" :class="{active:item.TotalCount>0}">
          <div class="img-box">
            <img :src="item.CoverImg || ''" alt="" :class="{active: item.CoverImg}">
            <div class="img-set" @click.stop="setCoverImg(item.Id,index)">设置封面</div>
          </div>
          <div class="item-info" >
            {{item.Name}}
            <span class="item-num">{{item.TotalCount}}</span>
            <img src="../../assets/img/edit_icon.png" alt="" class="fr item-edit" @click.stop="editFolder(item.Id,index)">
          </div>
        </router-link>
      </ul>
    </div>
    <div class="dialog" v-show="isDialogShow">
      <div class="model">
        <h3 class="mo-title">{{dialogTitle}}
          <span class="mo-close" @click="closeDialog">×</span>
        </h3>
        <div class="mo-content">
          <div v-show="dialogType==1">
            <div class="mo-item">
              标题 <input type="text" v-model="collectName" maxlength="13" placeholder="不能超过13个字符" required/>
            </div>
          </div>
          <div v-show="dialogType==2">
            <div class="mo-item">
              标题 <input type="text" v-model="collectName" maxlength="13" placeholder="不能超过13个字符" required/>
            </div>
            <div class="mo-item">
              封面 <input type="text" value="修改" readonly class="colorf93" @click="setCoverImg(folderId)" />
            </div>
            <div class="delete-col" @click="deleteFolder(folderId,nowIndex)">删除收藏夹</div>
          </div>
          <div v-show="dialogType==3">
            <div class="mo-item mo-warn-box">
              <span class="mo-warn">!</span>
              <span>确定要删除这个收藏夹吗？删除后这个收藏夹内的<br />所有图片都会被删除。</span>
            </div>
          </div>
          <div v-show="dialogType==4">
            <div class="mo-item">
              <label class="check">
                <input type="radio" name="cover" value="1" checked v-model="checkedValue" /> 使用默认封面（最新收藏）
              </label>
              <label class="check">
                <input type="radio" name="cover" value="2" :disabled="coverimgList.length==0" v-model="checkedValue" /> 使用自定义封面
              </label>
            </div>
            <div class="mo-line"></div>
            <banner @getIndex="getIndex" :coverimgList="coverimgList"  v-if="checkedValue==2"></banner>
          </div>
        </div>
        <div class="df mo-handel">
          <div class="mo-btn btn-sure" @click="verifyResult">{{verifyText || "保存"}}</div>
          <div class="mo-btn btn-cancel" @click="closeDialog">取消</div>
        </div>
      </div>
    </div>
    <div class="more" @click.stop="loadMore" v-show="!isAllLoad && !isLoading">
      <img src="../../../static/load_more.gif" alt="" class="more-img">
      <p>点击加载更多</p>
    </div>
    <warn ref="warn"></warn>
  </div>
</template>
<script>
import Banner from "../common/banner.vue"
import {getCollectList,addOrUpdateCollect,deleteCollect,getCoverimgList,updateCoverimg} from "@/assets/js/modules/userApi"
import Warn from "../common/warn.vue"
export default {
  components: {
    Banner,
    Warn,
  },
  data() {
    return {
      collectList: [],
      fileLength: 1,
      isDialogShow: false,
      dialogType: 1,  //弹窗类型 1--创建收藏夹, 2-- 编辑收藏夹, 3--删除确认, 4--设置封面
      dialogTitle: "创建收藏夹",    //弹窗标题
      collectName: "",    //收藏夹标题
      checkedValue: "1",   //单选框选中的值
      coverIndex: 0,     //设置封面时选择banner下标
      userId: "",
      folderId: "",     //收藏夹ID
      nowIndex: "",     //收藏夹下标
      coverimgList:[],
      verifyText: "",
      pageNum: 0,
      pageCount: 12,
      isAllLoad: false,
      isLoading: false
    }
  },
  created(){
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userId = userInfo.Id;
    this.getCollectList();
    this.$emit("getNavIndex",4);
  },
  methods: {
    //获取收藏夹列表
    getCollectList(){
      let data = {
        UserID: this.userId,
        SkipCount: this.pageNum * this.pageCount,
        MaxResultCount: this.pageCount
      };
      getCollectList(data).then(res=>{
        if(res.data.Success){
          let result = res.data.Data.Items;
          if(result.length>0){
            this.collectList = this.collectList.concat(res.data.Data.Items);
          }
          if(result.length<this.pageCount){
            this.isAllLoad = true;
          }
          
        }
      })
    },
    //点击加载更多
    loadMore(){
      if(!this.isAllLoad){
        this.pageNum++;
        this.getCollectList();
      }
    },
    //保存修改结果
    verifyResult() {
      let id = this.folderId;
      switch(this.dialogType){
        case 1: //add
          this.saveNewFolder();
          break;
        case 2: //change
          this.saveNewFolder(id);
          break;
        case 3: //delete
          this.deleteNowFolder(id,this.nowIndex);
          break;
        case 4: //set
          this.setFolderImg(id);
          break;
      }
    },
    //关闭弹出框
    closeDialog() {
      this.isDialogShow = false;
      this.checkedValue = 1;
    },
    closeWarn(){
      this.$refs.warn.closeWarn();
    },
    //创建收藏夹
    addFolder() {
      this.dialogTitle = "创建收藏夹";
      this.dialogType = 1;
      this.collectName = "";
      this.isDialogShow = true;
    },
    //编辑收藏夹
    editFolder(id,index) {
      this.folderId = id;
      this.nowIndex = index;
      this.collectName = this.collectList[index].Name;
      this.dialogTitle = "编辑收藏夹";
      this.verifyText = "保存";
      this.dialogType = 2;
      this.isDialogShow = true;
    },
    //删除收藏夹
    deleteFolder(id,index) {
      this.folderId = id;
      this.nowIndex = index;
      this.dialogTitle = "提示"
      this.verifyText = "删除";
      this.dialogType = 3;
    },
    //设置封面
    setCoverImg(id,index) {
      this.folderId = id;
      if(0==index){
        this.nowIndex = index;
      }else if(index){
        this.nowIndex = index;
      }
      this.verifyText = "保存";
      this.dialogTitle = "设置封面";
      this.dialogType = 4;
      this.isDialogShow = true;
      this.getCoverimgList();
    },
    //获取封面图
    getCoverimgList(){
       let data = {
        "FavoritesId": this.folderId,
        "Sorting": "CreationTime",
        "SkipCount": 0,
        "MaxResultCount": 999
      };
      getCoverimgList(data).then(res=>{
        if(res.data.Success){
          let result = res.data.Data;
          this.coverimgList = result.Items;
        }
      })
    },
    getIndex(data) {
      this.coverIndex = data; //获取下标
    },
    //添加收藏夹到服务器
    saveNewFolder(id){
      if(this.collectName.length==0) return;
      if(!this.justifyCollectName(this.collectName)){
        this.$refs.warn.message("已有同名文件夹!");
        return;
      }
      let data = {
        Id: id || "",
        Name: this.collectName,
        Sort: "0",
        UserId: this.userId
      };
      addOrUpdateCollect(data).then(res=>{
        if(res.data.Success){
          let result = res.data.Data;
          if(id){  //修改
            for(var i=0; i<this.collectList.length; i++){
              if(this.collectList[i].Id==id){
                this.collectList[i].Name = this.collectName;
                break;
              }
            }
          }else{  //新增
            result.TotalCount = 0;
            this.collectList.push(result);
            this.$refs.warn.message("收藏夹创建成功!");
          }
          this.isDialogShow = false;
          this.collectName = "";
        }
      })
    },
    //删除现有收藏夹
    deleteNowFolder(id,index){
      if(!id) return;
      deleteCollect({Id: id}).then(res=>{
        if(res.data.Success){
          this.collectList.splice(index,1);
          this.isDialogShow = false;
        }
      })
    },
    //设置收藏夹封面图
    setFolderImg(id){
      if(this.coverimgList.length==0){
        this.$refs.warn.message("此收藏夹没有收藏内容,赶快去收藏吧~");
        return;
      }
      let data = {
        Id: id,
        FavoritesId: this.checkedValue==1 ? "" : this.coverimgList[this.coverIndex].Id
      };
      updateCoverimg(data).then(res=>{
        if(res.data.Success){
          this.collectList[this.nowIndex].CoverImg = res.data.Data.CoverImg;
          this.$refs.warn.message("封面修改成功!");
          this.isDialogShow = false;
          this.checkedValue = 1;
        }
      })
    },
    //验证是否有同名收藏夹
    justifyCollectName(name){
      let list = this.collectList;
      for(var i=0; i<list.length; i++){
        if(list[i].Name === name){
          return false;
        }
      }
      return true;
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fbfbfb;
}

.no-pro {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999;
  text-align: center;
  min-height: 600px;
}

.no-pro img {
  margin-top: 6%;
}

.no-pro p {
  font-size: 18px;
  line-height: 28px;
  margin-top: 2%;
}

.share-btn {
  width: 286px;
  line-height: 38px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #ff9933;
  box-sizing: border-box;
  margin-top: 2%;
  cursor: pointer;
}

.share-btn:hover {
  color: #fff;
  background-color: #ff9933;
}

.collect-box {
  max-width: 1280px;
  min-height: 600px;
  margin: 0 auto;
  padding: 20px 0 50px;
}

.collect-list {
  margin-left: -20px;
}

.collect-item {
  width: 305px;
  height: 382px;
  margin: 0 0 20px 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #fff;
  transition: all 0.4s ease-in-out;
  animation: show-card 0.4s ease-in-out;
}
@keyframes show-card {
  0% {
    transform: scale(0.5)
  }
  100%{
    transform: scale(1);
  }
}
.collect-item.active{
  cursor: pointer;
}
.collect-item:hover{
    box-shadow: 0 1px 3px rgba(0, 0, 0, .02), 0 16px 32px -4px rgba(0, 0, 0, .17);
    transform: translateY(-2px);
}
.add-box {
  margin: 16px 12px;
  height: 350px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px dashed #e7e7e7;
  cursor: pointer;
}

.collect-item .add {
  font-size: 50px;
  color: #ccc;
  border: 2px solid #ccc;
  width: 50px;
  height: 50px;
  line-height: 40px;
  border-radius: 50%;
  margin-bottom: 5px;
  box-sizing: border-box;
}

.collect-item .img-box {
  padding: 16px 12px;
  position: relative;
  border-bottom: 1px solid #e7e7e7;
}

.img-box img {
  display: block;
  height: 296px;
  width: 100%;
  object-fit: cover;
  background-color: #e7e7e7;
}
.img-box img.active{
  background: none;
}

.img-box .img-set {
  position: absolute;
  right: 22px;
  bottom: 28px;
  font-size: 14px;
  line-height: 2;
  color: #fff;
  padding: 0 15px;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0;
  transition: all 0.5s;
  background-color: rgba(0, 0, 0, .6);
}

.img-box:hover .img-set {
  opacity: 1;
}

.img-box .img-set:hover {
  background-color: rgba(0, 0, 0, .8);
}

.item-info {
  padding: 16px 12px;
}

.item-num {
  color: #999;
  margin-left: 1em;
}

.item-edit {
  cursor: pointer;
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .2);
  z-index: 99;
}

.model {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 620px;
  padding-bottom: 40px;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 10px;
}

.mo-title {
  line-height: 80px;
  height: 80px;
  font-size: 18px;
  color: #333;
  text-align: center;
  position: relative;
  border-bottom: 1px solid #e7e7e7;
}

.mo-close {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 40px;
  line-height: 1;
  color: #999;
  cursor: pointer;
}

.mo-close:hover {
  color: #666;
}

.mo-content {
  padding: 40px 0;
}

.mo-item {
  display: flex;
  justify-content: center;
  font-size: 14px;
  line-height: 40px;
  margin-bottom: 15px;
  position: relative;
}

.mo-item input[type=text] {
  width: 380px;
  line-height: 40px;
  height: 40px;
  border: 1px solid #e7e7e7;
  background-color: #f8f8f8;
  box-sizing: border-box;
  border-radius: 5px;
  padding-left: 15px;
  color: #666;
  margin-left: 10px;
}

.mo-item input.colorf93 {
  color: #ff9933;
  cursor: pointer;
}

.delete-col {
  font-size: 14px;
  margin-left: 100px;
  cursor: pointer;
}

.delete-col:hover {
  color: #ff9933;
}

.mo-warn-box {
  line-height: 1.5;
  font-size: 16px;
}

.mo-warn {
  font-size: 42px;
  display: inline-block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #ff0000;
  color: #fff;
  text-align: center;
  line-height: 48px;
  margin-right: 20px;
}

.mo-item .check:first-of-type {
  margin-right: 30px;
}

.mo-item input[type="radio"]:checked::after {
  top: 16px;
}
.mo-item input[type="radio"]:disabled{
  background-color: #ddd;
  cursor: not-allowed;
}
.mo-line {
  border-bottom: 1px solid #e7e7e7;
  margin: 10px 20px;
}

.mo-handel {
  justify-content: center;
  text-align: center;
}

.mo-btn {
  width: 150px;
  height: 40px;
  line-height: 38px;
  border-radius: 20px;
  box-sizing: border-box;
  border: 1px solid #ff9933;
  cursor: pointer;
}

.btn-sure {
  background-color: #ff9933;
  color: #fff;
  margin-right: 30px;
}

.btn-sure:hover {
  background-color: #ff8833;
}

.btn-cancel {
  color: #999;
}

.btn-cancel:hover {
  background-color: #fbfbfb;
}
.more{
    padding: 10px;
    width: 49%;
    font-size: 16px;
    color: #999;
    margin: 20px auto;
    text-align: center;
    cursor: pointer;
}
.more-img{
  display: block;
  margin: 0 auto;
}
.more p{
  margin-top: -38px;
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/collect.vue